import { UTILITY_TYPES } from './utilityType';

export const REPORT_TYPE = {
  [UTILITY_TYPES.ELECTRIC_ENERGY]: 'anexa12' as 'anexa12',
  [UTILITY_TYPES.NATURAL_GAS]: 'anexa9' as 'anexa9',
  NORMAL: 'anexa' as 'anexa',
  ADMIN: 'anexa25' as 'anexa25'
};